import * as constants from './Paypal.constants';
import * as services from './Paypal.service';

const state = {
  paypalInfo: {
    token: '',
    PayerID: '',
  },
  isRequest: false,
};

const mutations = {
  [constants.SET_PAYPAL_INFO](state, paypalInfo) {
    state.paypalInfo = paypalInfo;
  },

  [constants.DUMMY_MUTATION]() { },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  setPaypalInfo({ commit }, payload) {
    commit(constants.SET_PAYPAL_INFO, payload);
  },

  async getMallPaypalInfo({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getMallPaypalInfo(payload);
    if (200 === res.data.status) {
      commit(constants.DUMMY_MUTATION, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },

  async getMallPaypalResult({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getMallPaypalResult(payload);
    if (200 === res.data.status && res.data.data.result) {
      commit(constants.DUMMY_MUTATION, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
